import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { images } from "../../assets";
export const LoadingIndicator = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("img", {
            src: images.SwiftSpinner,
            className: "size-36 blur-xs"
        })
    });
};
export default LoadingIndicator;

//# sourceMappingURL=LoadingIndicator.js.map